export default {
  data() {
    return {
      currentPage: 1,
      emptyResults: false,
    }
  },

  methods: {
    fetchRecords,
    fetchMore,
    setSortOrder,
  },
}
/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
async function fetchRecords() {
  const response = await this.$store.dispatch(this.fetchType, {
    page: this.currentPage,
    sort: this.sortOrder,
  })

  if (response.data?.length == 0) this.emptyResults = true
}

async function fetchMore(load = false) {
  if (load && !this.emptyResults) {
    this.currentPage++
    this.fetchRecords()
  }
}

function setSortOrder(order) {
  this.sortOrder = order
  this.currentPage = 1
  this.fetchRecords()
}
